import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { catchApiError } from '@cbridge-packages/api-base';
import { ICoverageApiDependencySegment } from '@cbridge-packages/api-coverage';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { CoverageAccountAction } from '@cbridge-packages/coverage-account';
import { CoverageReportAction } from '../coverageReport.action';

type IDependencies = ICoverageApiDependencySegment;

export const removeCoverageReportEpic: IEpic<{}, IDependencies> = (action$, _, { coverageApi }) => action$.pipe(
  isTypeOfAndGetPayload(CoverageReportAction.remove.started),
  mergeMap((params) => coverageApi.deleteCoverageReport(params.reportId).pipe(
    // The backend cascades the report's accounts — purge them locally as well.
    mergeMap(() => [
      CoverageReportAction.remove.done({ params }),
      CoverageAccountAction.removeByReport({ reportId: params.reportId }),
    ]),
    catchApiError((error) => [
      CoverageReportAction.remove.failed({ params, error }),
      createApiErrorNotification(error),
    ]),
  )),
);
